import { computed, unref, type Ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import Report from "@/services/analytics/report";

export interface SavedViewsParams {
  reportType: string;
}

export function useSavedViews(params: Ref<SavedViewsParams | null> | SavedViewsParams | null) {
  const queryKey = computed(() => {
    const p = unref(params);
    if (!p) return ["savedViews", "disabled"];
    return ["savedViews", p.reportType];
  });

  const enabled = computed(() => {
    const p = unref(params);
    return p !== null && p !== undefined && !!p.reportType;
  });

  return useQuery({
    queryKey,
    queryFn: async () => {
      const p = unref(params);
      if (!p) throw new Error("Parameters not ready");

      const result = await Report.getReportViews({ reportType: p.reportType });

      if (result.data?.status && result.data?.data) {
        return result.data.data.sort(
          (a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
      }

      return [];
    },
    enabled,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
